<div class="unauthorized-container"
     data-testid="unauthorized-container">
  <div class="unauthorized-content"
       data-testid="unauthorized-content">
    <img src="assets/icons/unauthorized-lock.svg"
         alt="Access Denied"
         class="unauthorized-icon"
         data-testid="unauthorized-icon">
    <h1 class="error-title"
        data-testid="unauthorized-title">Access Denied</h1>
    <p class="error-message"
       data-testid="unauthorized-message-main">
      You're signed in, but your account doesn't have permission to use this application.
    </p>
    <p class="error-message"
       data-testid="unauthorized-message-contact">
      Please reach out to your manager to request access.
    </p>
    <div class="retry-message error-message">
      If you believe this is an error, and would like to try again to authenticate, please click below.
      <p-button (click)="goToLogin()"
                severity="contrast"
                styleClass="bqa-primary-btn p-fullwidth-button"
                data-testid="unauthorized-retry-button">Retry Authentication</p-button>.
    </div>
  </div>
  <app-support-footer class="app-support-footer"></app-support-footer>
</div>